import { Link } from 'react-router';

import { routes } from '../../const/routes';
import './banner.scss';

const Banner = () => (
  <div className="banner__wrapper">
    <div className="banner__img" />
    <div className="banner__text">
      <h2>Start planning your project now</h2>
      <p>
        Get a comprehensive, precisely estimated software project quotation now.
        Know your costs and timeline upfront.
      </p>

      <div className="banner__buttons">
        <Link to={routes.formPage} className="primaryFatLink ic-arrow-up">
          Calculate for free
        </Link>
      </div>
    </div>
  </div>
);

export default Banner;
